import { render, staticRenderFns } from "./CategoriasLista.vue?vue&type=template&id=288b7843&scoped=true&"
import script from "./CategoriasLista.vue?vue&type=script&lang=js&"
export * from "./CategoriasLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288b7843",
  null
  
)

export default component.exports